import React from "react";
import Form from 'react-bootstrap/Form'

const SelectCat = (props) => {
    const handleSelect = (e) => {
        const targetValue = e.currentTarget.value;
        window.location.href = targetValue;
    }

    return (
        <div className={`${props.sectionClass}`}>
            <Form>
                {props.labelName && <Form.Label>{props.labelName}</Form.Label>}
                <Form.Control as="select" custom className="border-select" onChange={handleSelect} defaultValue={props.location.pathname}>
                    {props.selectOptions.map((option) => {
                        const catUrl = option.node.category ? '/'+option.node.category.Slug+'/'+option.node.Slug+'/' : '/'+option.node.Slug;
                        let labelName = '';
                        if ("Advice & Help" === option.node.labelName) {
                            labelName = "All Categories"
                        } else {
                            labelName = option.node.labelName;
                        }
                        return(
                            <option key={option.node.id} value={catUrl}>{labelName}</option>
                        )
                    })}
                </Form.Control>
            </Form>
        </div>
    )
}

// Specifies the default values for props:
SelectCat.defaultProps = {
    sectionClass: '',
    labelName: false,
    selectOptions: []
}

export default SelectCat